import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Callout = makeShortcode("Callout");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The `}<inlineCode parentName="p">{`paymentHandling`}</inlineCode>{` option defines how the SDK should handle payment creation and resume.`}</p>
    <p>{`The default is `}<inlineCode parentName="p">{`AUTO`}</inlineCode>{`, set `}<inlineCode parentName="p">{`paymentHandling`}</inlineCode>{` to `}<inlineCode parentName="p">{`MANUAL`}</inlineCode>{` to turn off automatic payment handling. This disables the callbacks `}<inlineCode parentName="p">{`onBeforePayment`}</inlineCode>{` and `}<inlineCode parentName="p">{`onCheckoutComplete`}</inlineCode>{`.`}</p>
    <p>{`Two callbacks must be implemented:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`onTokenizeSuccess()`}</inlineCode>{` to create payments with the `}<inlineCode parentName="li">{`paymentMethodToken`}</inlineCode>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`onResumeSuccess()`}</inlineCode>{` to resume payments with `}<inlineCode parentName="li">{`resumeToken`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`See the `}<a parentName="p" {...{
        "href": "/docs/payments/universal-checkout/advanced-topics/manual-payment-creation/web"
      }}>{`Manual Payment Creation`}</a>{` guide for examples.`}</p>
    <Callout emoji='ℹ️' mdxType="Callout">
      <p>{`The guide's examples are written for `}<inlineCode parentName="p">{`PrimerCheckout`}</inlineCode>{`, but the same concepts apply to `}<inlineCode parentName="p">{`PrimerHeadlessCheckout`}</inlineCode>{`.`}</p>
    </Callout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      